import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ImageService } from '../../../../../services/image/image.service';
import { SocialChannelEnum } from '@/app/common/general-types/briefs.dto';
import { signal } from '@angular/core';
import { VideoThumbnailComponent } from '../../../../../atoms/video-thumbnail/video-thumbnail.component';

@Component({
  selector: 'brief-feed-posted-sub-post',
  standalone: true,
  imports: [VideoThumbnailComponent],
  templateUrl: './feed-posted-sub-post.component.html',
  styleUrl: './feed-posted-sub-post.component.css'
})
export class FeedPostedSubPostComponent implements OnChanges {

  @Input('application') application!: any;
  @Input('socialChannel') socialChannel: SocialChannelEnum | 'UGC' = 'UGC';
  usefulNetwork = signal<SocialChannelEnum | 'UGC' | undefined>(undefined);

  /** Services */
  public imageService = inject(ImageService);
  /** Services END */

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['socialChannel']) {
      this.socialChannel = changes['socialChannel'].currentValue;

      if (this.socialChannel === 'UGC') {
        this.usefulNetwork.set('UGC');
      } else {
        this.usefulNetwork.set(this.socialChannel);
      }
    }
  }

  getFanTransform(index: number, total: number): string {
    const spread = Math.min(40, total * 8);
    const step = spread / (total - 1);
    const rotation = -spread / 2 + index * step;
    return `rotate(${rotation}deg)`;
  }

  getThumbnail(videoId: string) {
    const video = this.application.applicationVideos?.find((v: any) => v.id === videoId);
    if (!video) {
      return this.imageService.getImageSource('', 'gallery');
    }
    if (video && video.thumbnailURL) {
      return this.imageService.getImageSource(video.thumbnailURL, 'thumbnail');
    } else if (video && !video.thumbnailURL) {
      return this.imageService.getImageSource(video.fullUrl, 'thumbnail');
    }
    else {
      return this.imageService.getImageSource('', 'gallery');
    }
  }

  hasThumbnail(videoId: string) {
    const video = this.application.applicationVideos?.find((v: any) => v.id === videoId);
    if (!video) {
      return false;
    }
    return video.thumbnailURL ? true : false;
  }

  viewPost(post: any) {
    console.log('🎃🎃🎃 viewPost', post);
    window.open(post.videoLink, '_blank');
  }

  getHandleAndNetwork() {
    // Do not use `if (this.socialChannel)` — TikTok Post is enum value 0 (falsy).
    switch (this.usefulNetwork()) {
      case SocialChannelEnum['TikTok Post']:
        return `@${ this.application.creator.tikTokHandle }`;
      case SocialChannelEnum['Instagram Reel']:
        return `@${ this.application.creator.instaHandle }`;
      case SocialChannelEnum['YouTube Shorts']:
        return `@${ this.application.creator.youtubeHandle }`;
      case SocialChannelEnum['Instagram Story']:
        return `@${ this.application.creator.instaHandle }`;
      case SocialChannelEnum['Snapchat Spotlight']:
        return `@${ this.application.creator.snapchatHandle }`;
      case SocialChannelEnum['Snapchat Story']:
        return `@${ this.application.creator.snapchatHandle }`;
      default:
        return `UGC Content`;
    }
  }
}
